module.exports = __webpack_public_path__ + "static/media/homeIconColored.9407f6a0.svg";